import request from '@/utils/request'
import qs from 'qs'

const getClassesById = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/classes/${id}`,
    method: 'get'
  })
}

const getClassesPageList = (query) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/classes/page-list`,
    method: 'get',
    params: query
  })
}

const getClassesIdAllByMajorId = (majorId) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/classes/classes-id-all-by-major-id/${majorId}`,
    method: 'get'
  })
}

const getClassesByName = (name) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/classes/by-name`,
    method: 'get',
    params: { name }
  })
}

function createClasses(data) {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/classes`,
    method: 'post',
    data
  })
}

const updateClasses = (id, data) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/classes/${id}`,
    method: 'put',
    data
  })
}

const queryClasses = (query) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/classes/query`,
    method: 'get',
    params: query
  })
}

const getClassesCache = () => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/classes/cache`,
    method: 'get'
  })
}

const updateClassesStateByIds = (ids, state) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/classes/state`,
    method: 'put',
    params: { state },
    data: ids
  })
}

const checkName = (name) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/classes/check-name`,
    method: 'post',
    params: { name }
  })
}

const getByCompanyIdAndMajorIdAndName = (companyId, majorId, name) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/classes/by-company-id-and-major-id-and-name`,
    method: 'get',
    params: { companyId, majorId, name }
  })
}

const getByName = (name) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/classes/by-class-name`,
    method: 'get',
    params: { name }
  })
}

const getClassesAllByCompanyId = (company) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/classes/classes-all-by-company-id`,
    method: 'get',
    params: { company }
  })
}

const getClassesAll = () => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/classes/classes-all`,
    method: 'get'
  })
}

const deleteClassesByIds = (ids) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/classes/classes`,
    method: 'delete',
    params: { ids },
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

const getClassesTotalByCompanyIds = (companyIds) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/classes/classes-total-by-company-ids`,
    method: 'get',
    params: { companyIds },
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

const getClassesTotalByMajorIds = (majorIds) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/classes/classes-total-by-major-ids`,
    method: 'get',
    params: { majorIds },
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

const getClassesAndTrainingPlan = (platform) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/classes/classes-and-training-plan`,
    method: 'get',
    params: { platform }
  })
}

export default {
  createClasses,
  updateClasses,
  getClassesPageList,
  getClassesIdAllByMajorId,
  getClassesById,
  getClassesByName,
  queryClasses,
  getClassesCache,
  updateClassesStateByIds,
  checkName,
  getByCompanyIdAndMajorIdAndName,
  getByName,
  getClassesAllByCompanyId,
  getClassesAll,
  deleteClassesByIds,
  getClassesTotalByCompanyIds,
  getClassesTotalByMajorIds,
  getClassesAndTrainingPlan
}
